import React from 'react';
import { faChevronRight, faArrowCircleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

const helpResourceItem = [
  {
    id: 1,
    title: 'Support Quick Guides',
    child: [
      {
        name: 'Creating Classes',
        link: '/Documents/CreatingClassesQuickGuide.PDF'
      },
      {
        name: 'Co-Teachers Quick Guide',
        link: '/Documents/CoTeachersQuickGuide.PDF'
      },
      {
        name: 'Assignment Modes/Settings',
        link: '/Documents/AssignmentModes-SettingsQuickGuide.PDF'
      },
      {
        name: 'Question Search',
        link: '/Documents/QuestionSearchQuickGuide.PDF'
      },
      {
        name: 'Keyword Search',
        link: '/Documents/KeywordSearchQuickGuide.PDF'
      },
      {
        name: 'Literature Sets',
        link: '//Documents/Literature_Set_Quick_Guide.PDF'
      },
      {
        name: 'NYS Regents',
        link: '//Documents/Regents_Quick_Guide.PDF'
      },
      {
        name: 'Assigning Assignments',
        link: '//Documents/AssigningAssignmentsQuickGuide.PDF'
      },
      {
        name: 'Chrome Browser Lockdown',
        link: '//Documents/Browser%20Lockdown%20Guide.PDF'
      },
      {
        name: 'Printing Assignments',
        link: '/Documents/PrintingAssignmentsQuickGuide.PDF'
      },
      {
        name: 'Change Mode/Settings',
        link: '/Documents/ChangeMode-SettingsQuickGuide.PDF'
      },
      {
        name: 'Text to Speech',
        link: '/Documents/TexttoSpeechQuickGuide.PDF'
      },
      {
        name: 'Text to Speech',
        link: '/Documents/TexttoSpeechQuickGuide.PDF'
      },
      {
        name: 'Assignment Results',
        link: 'Documents/AssignmentResultsQuickGuide.PDF'
      },
      {
        name: 'Grade CR (Constructed Response)',
        link: 'Documents/GradeCRQuickGuide.PDF'
      },
      {
        name: 'Reports',
        link: 'Documents/ReportsQuickGuide.PDF'
      },
      {
        name: 'Assignment Folders',
        link: '/Documents/Assignment_Folders_Quick_Guide.PDF'
      },
      {
        name: 'Duplicating Assignments',
        link: '/Documents/Duplicating_Assignments_Quick_Guide.PDF'
      },
      {
        name: 'Sharing Assignments',
        link: '/Documents/SharingAssignmentsQuickGuide.PDF'
      },
      {
        name: 'Self Study Results',
        link: '/Documents/SelfStudyResults_QuickGuide.PDF'
      },
      {
        name: 'Sharing Assignments',
        link: '/Documents/SharingAssignmentsQuickGuide.PDF'
      },
      {
        name: 'Student Generated Practice Assignment',
        link: '/Documents/StudentGeneratedPracticeAssignment_QuickGuide.PDFF'
      },
      {
        name: 'Clearing Student Passwords',
        link: '/Documents/ClearingStudentPasswordsQuickGuide.PDF'
      },
      {
        name: 'Password Reset',
        link: '/Documents/PasswordResetQuickGuide.PDF'
      }
    ]
  },
  {
    id: 2,
    title: 'Information for Administrators',
    child: [
      {
        name: 'Enrollment Procedures',
        link: '/Documents/Enrollment%20Procedures.pdf'
      },
      {
        name: 'Admin - Quick Guide',
        link: '/Documents/Admin%20-%20Quick%20Guide.pdf'
      },
      {
        name: 'Assessments How to Guide',
        link: '/Documents/Assessments_How_to_Guide.pdf'
      }
    ]
  },

  {
    id: 3,
    title: 'Information for Teachers',
    child: [
      {
        name: 'Enrollment Procedures',
        link: '/Documents/Enrollment%20Procedures.pdf'
      },
      {
        name: 'Admin - Quick Guide',
        link: '/Documents/Admin%20-%20Quick%20Guide.pdf'
      },
      {
        name: 'Assessments How to Guide',
        link: '/Documents/Assessments_How_to_Guide.pdf'
      },
      {
        name: 'Google Classroom Guide',
        link: '/Documents/Google_Classroom_Guide.pdf'
      },
      {
        name: 'Schoology Guide',
        link: '/Documents/Schoology_Guide.pdf'
      },
      {
        name: 'Automated Retakes Guide',
        link: '/Documents/Castle%20Learning%20Automated%20Retakes%20Guide.pdf'
      },
      {
        name: 'Automated Retakes FAQ',
        link: '/Documents/Castle%20Learning%20Automated%20Retakes%20FAQ.pdf'
      },
      {
        name: 'Teacher Guide - Level One',

        link: '/Documents/Teacher%20Guide%20-%20Level%20Two.pdf'
      },
      {
        name: 'Teacher Guide - Level Two',
        link: '/Documents/Teacher Guide - Level Two.pdf'
      },
      {
        name: 'Teacher Guide - Offline Mode',
        link: '/documents/Offline Mode Guide.pdf'
      },
      {
        name: 'Spanish and French Grammar Charts',
        link: '/documents/Spanish and French Grammar Charts.pdf'
      },
      {
        name: 'Spanish for Beginners Grammar Chart',
        link: '/documents/Beginning Spanish Grammar Chart.pdf'
      },
      {
        name: 'NY Regents Guide for Teachers',
        link: '/Documents/NY Regents Guide for Teachers.pdf'
      },
      {
        name: 'Spanish Translation Regents Questions Guide',

        link: '/Documents/Spanish Translation Regents Questions Guide NEW.pdf'
      },
      {
        name: 'NY State Samplers Grades 3-8 Guide',
        link: '/Documents/NY State Samplers Grades 3-8 Guide.pdf'
      },
      {
        name: 'PCS Guide #2- Write Your Own Questions',
        link: '/Documents/PCS_Guide_2_Write_Your_Own_Questions.pdf'
      },
      {
        name: 'PCS Guide #3 - Creating and Attaching Documents',
        link: '/Documents/PCS Guide %233- Creating and Attaching Documents to an Assignment.pdf'
      },
      {
        name: 'Student Printing Guide',
        link: '/Documents/Student_Printing_PDF_Guide.pdf'
      },
      {
        name: 'Data Analysis',
        link: '/Documents/DataAnalysis_and_GrowthReport.pdf'
      },
      {
        name: 'Credit Recovery',
        link: '/Documents/Credit_Recovery_Guide.pdf'
      }
    ]
  },

  {
    id: 4,
    title: 'Information for Students',
    child: [
      {
        name: ' Student Regents Review Guide',
        link: '/Documents/Student Regents Review Guide.pdf'
      },
      {
        name: 'Student Access How to Guide',
        link: '/Documents/Student Access How to Guide.pdf'
      },
      {
        name: 'CBT Tools Guide',
        link: '/Documents/Student_Center_CBT_Tools_ Guide.pdf'
      },
      {
        name: 'Student Profile - Secondary Email Address',
        link: '/Documents/StudentProfileSecondaryEmailAddress.PDF'
      },
      {
        name: 'Student Self Study Guide',
        link: '/Documents/StudentSelfStudy_Guide.PDF'
      }
    ]
  },

  {
    id: 5,
    title: 'Information for Parents',
    child: [
      {
        name: 'Parent Letter',
        link: '/Documents/Parent%20Letter.pdf'
      },
      {
        name: 'Parent Letter (Spanish)',
        link: '/Documents/Parent%20Letter%20Spanish.pdf'
      }
    ]
  },

  {
    id: 6,
    title: 'General Information:',
    child: [
      {
        name: 'Terms of Service',
        link: 'https://harriseducationsolutions.com/wp-content/uploads/2026/09/SaaS-Agreement-Castle-Software-Inc.-SaaS-Agreement-used-for-Castle-Learning.pdf-Harris-Education-Nextcloud.pdf'
      },
      {
        name: 'Privacy Policy',
        link: 'https://harriseducationsolutions.com/privacy-policy/'
      },
      {
        name: 'System Requirements',
        link: '/Documents/SystemRequirementsQuickGuide.pdf'
      }
    ]
  }
];

const HelpResourceDoc = () => {
  const [expand, setExpand] = React.useState(false);
  const [activeIndex, setActiveIndex] = React.useState(0);
  const expandhandler = (index) => {
    setActiveIndex(index == activeIndex ? -1 : index);
    setExpand(index !== activeIndex || !expand);
  };
  return (
    <div className="white-card">
      <div className="help_resource_header">
        <h2>Help Resource Documents</h2>
        <p>
          Various Castle Learning documents are available in PDF format. You will need Adobe Acrobat
          Reader or a compatible browser to open these documents.
        </p>
        <p>Click the links below to view and print the documents.</p>
      </div>

      {helpResourceItem.map((item, index) => {
        return (
          <div key={index} className="help_resource_tap">
            <div
              key={index}
              onClick={() => expandhandler(index)}
              className="help_resource_tap_header d-flex justify-content-between m-2">
              <h2>{item.title}</h2>
              <span
                style={{
                  transform: `${activeIndex == index && expand ? 'rotate(90deg)' : 'rotate(0deg)'}`
                }}>
                <FontAwesomeIcon size="2xl" icon={faChevronRight} />
              </span>
            </div>
            {activeIndex == index && expand && (
              <div className="help_resource_grid ">
                {item.child.map((value, index) => (
                  <Link
                    style={{ textDecoration: 'none', color: 'gray' }}
                    to={value.link}
                    key={index}
                    target="_blank"
                    class="help_resource_content text-center p-3 d-flex justify-content-between">
                    {value.name}
                    <FontAwesomeIcon size="2xl" icon={faArrowCircleRight} />
                  </Link>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default HelpResourceDoc;
